import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { TDealType } from '@cian/price-history-change-widget';

export function getDealType(offer: IOfferSchema): TDealType {
  if (offer.category.includes('daily')) {
    return 'rentDaily';
  }

  return offer.dealType;
}
